import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    filters: {
      display: 'flex',
      columnGap: theme.spacing(0.5),
      margin: theme.spacing(1, 0, 2),
    },
    menuHeader: {
      padding: theme.spacing(2, 2, 0),
      margin: theme.spacing(0.5, -2, 1),
      borderTop: theme.shape.borderGray70,
      fontSize: theme.typography.pxToRem(11),
      lineHeight: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightSemiBold,
      color: COLORS.gray.gray30,
      textTransform: 'uppercase',
    },
    menuListImage: {
      width: 'fit-content',
      minWidth: 420,
      maxWidth: 420,
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: theme.spacing(1.75),
      paddingTop: theme.spacing(0.75),
    },
  }),
  { name: 'SearchResults' }
);
